export const muiFormBindings = {
  TextField: ({ $try, field, props }: any) => ({
    id: $try(props.id, field.id),
    name: $try(props.name, field.name),
    type: $try(props.type, field.type),
    value: $try(props.value, field.value),
    label: $try(props.label, field.label),
    placeholder: $try(props.placeholder, field.placeholder),
    helperText: $try(props.error, field.error),
    error: !!props.error || !!field.error, // hasError doesn't clear at the right times
    disabled: $try(props.disabled, field.disabled),
    onChange: $try(props.onChange, field.onChange),
    onBlur: $try(props.onBlur, field.onBlur),
    onFocus: $try(props.onFocus, field.onFocus),
    autoFocus: $try(props.autoFocus, field.autoFocus),
  }),
  Select: ({ $try, field, props }: any) => ({
    id: $try(props.id, field.id),
    name: $try(props.name, field.name),
    value: $try(props.value, field.value),
    label: $try(props.label, field.label),
    placeholder: $try(props.placeholder, field.placeholder),
    helperText: $try(props.error, field.error),
    error: !!props.error || !!field.error,
    disabled: $try(props.disabled, field.disabled),
    onChange: $try(props.onChange, field.onChange),
    onBlur: $try(props.onBlur, field.onBlur),
    onFocus: $try(props.onFocus, field.onFocus),
  }),
  Checkbox: ({ $try, field, props }: any) => ({
    id: $try(props.id, field.id),
    name: $try(props.name, field.name),
    checked: $try(props.value, field.value),
    disabled: $try(props.disabled, field.disabled),
    onChange: $try(props.onChange, field.onChange),
    onBlur: $try(props.onBlur, field.onBlur),
    onFocus: $try(props.onFocus, field.onFocus),
  }),
  AutoCompleteTextField: ({ $try, field, props }: any) => ({
    id: $try(props.id, field.id),
    name: $try(props.name, field.name),
    type: $try(props.type, field.type),
    label: $try(props.label, field.label),
    placeholder: $try(props.placeholder, field.placeholder),
    helperText: $try(props.error, field.error),
    error: !!props.error || !!field.error, // hasError doesn't clear at the right times
    disabled: $try(props.disabled, field.disabled),
    onBlur: $try(props.onBlur, field.onBlur),
    onFocus: $try(props.onFocus, field.onFocus),
    autoFocus: $try(props.autoFocus, field.autoFocus),
  }),
};
